import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/InvoiceTypeReqs/InvoiceTypeReqs'


function* getInvoiceTypes(action) {
    try {
        const result = yield call(req.getInvoiceTypesReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_INVOICE_TYPES_SUCCESS, payload: result });
        } else {
            yield put({ type: types.GET_INVOICE_TYPES_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch invoice types");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICE_TYPES_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* getInvoiceTypeDetails(action) {
    try {
        const result = yield call(req.getInvoiceTypeDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_INVOICE_TYPE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_INVOICE_TYPE_DETAILS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch details");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICE_TYPE_DETAILS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* createInvoiceType(action) {
    try {
        const result = yield call(req.createInvoiceTypeReq, action);
        if (result.success === true) {
            toast.success(result.message || "Invoice type created successfully");
            yield put({ type: types.CREATE_INVOICE_TYPE_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CREATE_INVOICE_TYPE_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to create invoice type");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_INVOICE_TYPE_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* updateInvoiceType(action) {
    try {
        const result = yield call(req.updateInvoiceTypeReq, action);
        if (result.success === true) {
            toast.success(result.message || "Invoice type updated successfully");
            yield put({ type: types.UPDATE_INVOICE_TYPE_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.UPDATE_INVOICE_TYPE_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to update invoice type");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_INVOICE_TYPE_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* deleteInvoiceType(action) {
    try {
        const result = yield call(req.deleteInvoiceTypeReq, action);
        if (result.success === true) {
            toast.success(result.message || "Invoice type deleted successfully");
            yield put({ type: types.DELETE_INVOICE_TYPE_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.DELETE_INVOICE_TYPE_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to delete invoice type");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_INVOICE_TYPE_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


export default function* invoiceTypeSaga() {
    yield takeLatest(types.GET_INVOICE_TYPES, getInvoiceTypes);
    yield takeLatest(types.GET_INVOICE_TYPE_DETAILS, getInvoiceTypeDetails);
    yield takeLatest(types.CREATE_INVOICE_TYPE, createInvoiceType);
    yield takeLatest(types.UPDATE_INVOICE_TYPE, updateInvoiceType);
    yield takeLatest(types.DELETE_INVOICE_TYPE, deleteInvoiceType);
}
